import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "32",
      cy: "32",
      r: "32",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("rect", {
      width: "5.053",
      height: "25.263",
      x: "43.391",
      y: "21.834",
      fill: "#fff",
      rx: "2.526",
      transform: "rotate(45 43.39 21.834)"
    }, null, -1),
    _createElementVNode("rect", {
      width: "5.053",
      height: "18.526",
      x: "16",
      y: "30.172",
      fill: "#fff",
      rx: "2.526",
      transform: "rotate(-45 16 30.172)"
    }, null, -1)
  ])))
}
export default { render: render }